import { subscriberIcon } from '@assets/images/subscriber-icon'
import { size as themeSize } from '@styles/theme'
import styled from '@emotion/styled'

const Icon = styled.img`
  flex-shrink: 0;
  aspect-ratio: 1;
  object-fit: cover;
`

const SubscriberIcon = ({ size=1.75, style={}, ...rest }) => {
  return (
    <Icon
      style={{ height: themeSize(size), width: themeSize(size), ...style }}
      src={subscriberIcon}
      {...rest}
    />
  )
}

export { SubscriberIcon }
